import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Button,
  Modal,
  message,
  Spin,
  Divider,
  Tag,
  Space,
  Typography,
  Table,
  Descriptions,
  Row,
  Col,
} from "antd";
import {
  FileTextOutlined,
  BankOutlined,
  CalendarOutlined,
  DollarOutlined,
  FileSearchOutlined,
  FilePdfOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import axios from "axios";

// import EditJudgeModal from "./EditJudgeModal";
import {
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_BILL_PAYMENT,
  POST_LOAD_DETAIL_OLD_DATA,
  POST_LOAN_DB2,
} from "../../../API/apiUrls";
import PayInSlipModal from "../report/QRcode";
import ProductTranfer from "../report/ProductTranfer";
import ProductTranferAccount from "../report/ProductTranferAccount";

const { Text } = Typography;

const PdfPreviewModal = ({ open, url, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width="90vw"
    style={{ top: 10 }}
    title="ข้อมูล PDF"
  >
    <iframe
      src={url}
      style={{ width: "100%", height: "80vh", border: "none" }}
      title="pdf-preview"
    />
  </Modal>
);

const getDocLabel = (menuType, imageType) => {
  // menuType 5 = คำฟ้อง
  if (menuType === 5 && imageType === 3)
    return { label: "ไฟล์คำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  if (menuType === 5 && imageType === 4)
    return { label: "ใบเสร็จศาลคำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  // menuType 6 = ศาลตัดสิน
  if (menuType === 6 && imageType === 7)
    return { label: "คำพิพากษา", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 8)
    return { label: "คำพิพากษา(ทำยอม)", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 9)
    return { label: "ถอนฟ้อง", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 10)
    return { label: "ใบเสร็จศาลหลังพิพากษา", color: "#389e0d" }; // เขียวเข้ม
  if (menuType === 6 && imageType === 12)
    return { label: "วางคำบังคับ", color: "#096dd9" }; // น้ำเงินเข้ม
  // menuType 8 = ปิดบัญชี
  if (menuType === 8 && imageType === 13)
    return { label: "ใบตัดจ่าย", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 8 && imageType === 14)
    return { label: "ใบเสร็จปิดบัญชี", color: "#096dd9" }; // น้ำเงินเข้ม
  return { label: "เอกสาร", color: "#595959" }; // เทาเข้ม
};

// ========================================
// Utility Functions
// ========================================
const formatMoney = (value) => {
  if (!value && value !== 0) return "-";
  return Number(value).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// ========================================
// Main Component
// ========================================
const BillAfterCourtOldData = ({ open, close, dataDefault, status }) => {
  const token = localStorage.getItem("TOKEN");
  // States
  const [loading, setLoading] = useState(false);
  const [judgeData, setJudgeData] = useState(null);
  const [lawsuitData, setLawsuitData] = useState(null);
  const [arothrData, setArothrData] = useState([]);
  const [dataDB2, setDataDB2] = useState(null);
  const [billPayment, setBillPayment] = useState(null);
  const [isModalpayIn, setIsModalPayIn] = useState(false);
  const [isModalProductTranfer, setIsModalProductTranfer] = useState(false);
  const [isModalProductTranferAccount, setIsModalProductTranferAccount] =
    useState(false);

  const [fileListByContract, setFileListByContract] = useState([]);
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");

  // ========================================
  // AROTHR Options for display
  // ========================================
  const arothrOptions = useMemo(
    () => [
      { value: "111", label: "ค่าติดตาม" },
      { value: "222", label: "ค่าทนาย" },
      { value: "333", label: "ค่าธรรมเนียม" },
      { value: "444", label: "ค่าใช้จ่ายอื่นๆ" },
    ],
    [],
  );

  // ========================================
  // Load Main Data
  // ========================================
  const loadData = useCallback(async () => {
    if (!dataDefault?.lawsuitId) return;

    setLoading(true);
    try {
      const [loadDetailOldData, loadDataDB2, loadBillPayment] =
        await Promise.all([
          axios.post(
            POST_LOAD_DETAIL_OLD_DATA,
            {
              CONTNO: dataDefault.newContno,
              loanId: dataDefault.loanId,
              lawsuitId: dataDefault.lawsuitId,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
          axios.post(
            POST_LOAN_DB2,
            {
              CONTNO: `'${dataDefault.CONTNO}'`,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
          axios.post(
            POST_BILL_PAYMENT,
            {
              CONTNO: dataDefault.newContno || "V" + dataDefault.CONTNO,
            },
            { headers: HEADERS_EXPORT_BEN },
          ),
        ]);

      if (loadDetailOldData?.data) {
        console.log("✅ loadDetailOldData:", loadDetailOldData.data);
        const { judge, lawsult, arothr } = loadDetailOldData.data;

        setJudgeData(judge || null);
        setLawsuitData(lawsult || null);
        setArothrData(arothr || []);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
      if (loadDataDB2?.data) {
        console.log("✅ loadDataDB2:", loadDataDB2?.data[0]);
        setDataDB2(loadDataDB2?.data[0] || null);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
      if (loadBillPayment?.data) {
        console.log("✅ loadBillPayment:", loadBillPayment.data);
        setBillPayment(loadBillPayment.data);
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }
    } catch (error) {
      console.error("❌ Error loading data:", error);
      message.error(
        error.detailOldData?.data?.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล",
      );
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);
  console.log(dataDefault);

  const loadPath = useCallback(async () => {
    setLoading(true);
    try {
      const [imgRes5, imgRes6] = await Promise.all([
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/5/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/6/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
      ]);

      const mapImg = (img) => ({
        ...img,
        CONTNO: dataDefault.CONTNO,
        loanId: dataDefault.loanId,
        lawsuitId: dataDefault.lawsuitId,
      });

      const allImages = [
        ...(imgRes5.data || []).map(mapImg),
        ...(imgRes6.data || []).map(mapImg),
      ];

      if (allImages.length === 0) {
        message.warning("ไม่พบรูปภาพ");
      }

      setFileListByContract(allImages);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  useEffect(() => {
    if (open) {
      loadData();
      loadPath();
    }
  }, [open, loadData, loadPath]);

  // ========================================
  // Handle Cancel
  // ========================================
  const handleCancel = useCallback(() => {
    setJudgeData(null);
    setLawsuitData(null);
    setArothrData([]);
    close(false);
  }, [close]);

  // ========================================
  // Render Judge Info
  // ========================================
  const renderJudgeInfo = useMemo(() => {
    if (!judgeData) return null;

    const { judgeDef, loanNew } = judgeData;

    const defendantColumns = [
      {
        title: "จำเลยที่",
        dataIndex: "defendantNumber",
        key: "defendantNumber",
        width: 80,
        align: "center",
        render: (val) => <Tag color="blue">{val}</Tag>,
      },
      {
        title: "รหัสลูกค้า",
        dataIndex: "customerId",
        key: "customerId",
        render: (val) => <Text style={{ fontFamily: "monospace" }}>{val}</Text>,
      },
      {
        title: "ยอดคงเหลือ",
        dataIndex: "TONBALANCE",
        key: "TONBALANCE",
        align: "right",
        render: (val) => <Text>{formatMoney(val)} บาท</Text>,
      },
      {
        title: "อัตราดอกเบี้ย",
        dataIndex: "interestRate",
        key: "interestRate",
        align: "center",
        render: (val) => <Text>{val || 0}%</Text>,
      },
      {
        title: "ค่าขาดประโยชน์",
        dataIndex: "costOfUselessness",
        key: "costOfUselessness",
        align: "right",
        render: (val) => <Text>{formatMoney(val)} บาท</Text>,
      },
      {
        title: "วันที่สร้าง",
        dataIndex: "CreatedAt",
        key: "CreatedAt",
        render: (val) => formatDate(val),
      },
    ];

    const FLAG_CONFIG = {
      1: {
        background: "#f6ffed",
        border: "1px solid #b7eb8f",
        label: "ทำยอม",
        badgeColor: "#389e0d",
        badgeBg: "#d9f7be",
      },
      2: {
        background: "#fff2f0",
        border: "1px solid #ffccc7",
        label: "พิพากษา",
        badgeColor: "#cf1322",
        badgeBg: "#ffebe8",
      },
      6: {
        background: "#fff2f0",
        border: "1px solid #ffccc7",
        label: "(ส่วนต่าง)",
        badgeColor: "#cf1322",
        badgeBg: "#ffebe8",
      },
    };

    const flagStyle =
      FLAG_CONFIG[dataDefault.flagLoanNew || status] ?? FLAG_CONFIG[1];
    const lawStyle = dataDefault.LAW_TYPE_ID === 6 && FLAG_CONFIG[6];

    return (
      <>
        <Divider orientation="left">
          <Space size={6}>
            <BankOutlined />
            ข้อมูลคำพิพากษา
            <span
              style={{
                background: flagStyle.badgeBg,
                color: flagStyle.badgeColor,
                borderRadius: 20,
                padding: "2px 10px",
                fontSize: 20,
                fontWeight: 500,
              }}
            >
              {flagStyle.label}
              {lawStyle.label}
            </span>
            {dataDefault.parcelNo && (
              <span
                style={{
                  background: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  badgeColor: "#389e0d",
                  borderRadius: 20,
                  padding: "2px 10px",
                  fontSize: 16,
                  fontWeight: 500,
                }}
              >
                <Text copyable> {dataDefault.parcelNo}</Text>
              </span>
            )}
          </Space>
        </Divider>

        <div
          style={{
            background: "#f6ffed",
            border: "1px solid #b7eb8f",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "16px",
          }}
        >
          <Descriptions bordered size="small" column={{ xs: 1, sm: 2, md: 3 }}>
            <Descriptions.Item label="เลขคดีแดง">
              <Text strong copyable>
                {judgeData.redCaseNumber || "-"}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="เลขสัญญาใหม่">
              <Text strong copyable>
                {judgeData.newContno || "-"}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="วันพิพากษา">
              {formatDate(judgeData.judgeDate)}
            </Descriptions.Item>
            <Descriptions.Item label="ค่าชดใช้แทน">
              <Text strong style={{ color: "#cf1322" }}>
                {formatMoney(judgeData.judgement)} บาท{" "}
                {!parseInt(judgeData.judgeInterestRate)
                  ? null
                  : ` ดอกเบี้ย ${judgeData.judgeInterestRate}%`}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ต้นเงิน">
              <Text>
                {formatMoney(judgeData.judgementLack)} บาท{" "}
                {!parseInt(judgeData.interestRate)
                  ? null
                  : ` ดอกเบี้ย ${judgeData.interestRate}%`}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ดอกเบี้ยก่อนฟ้อง">
              <Text>{formatMoney(judgeData.judgementInterest)} บาท</Text>
            </Descriptions.Item>
            {/* <Descriptions.Item label="ยอดคงเหลือ">
              <Text strong style={{ color: "#fa541c" }}>
                {formatMoney(judgeData.TONBALANCE)} บาท
              </Text>
            </Descriptions.Item> */}
            <Descriptions.Item label="ค่าขาดประโยชน์">
              <Text>
                {formatMoney(judgeData.lackOfBenefits)} บาท{" "}
                {!parseInt(judgeData.interestRateOfLack)
                  ? null
                  : ` ดอกเบี้ย ${judgeData.interestRateOfLack}%`}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าขาดประโยชน์รายเดือน">
              <Text>
                {formatMoney(judgeData?.judgeDef[0]?.costOfUselesenessPerMonth)}{" "}
                บาท{" "}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ระยะเวลาค่าขาดประโยชน์รายเดือน">
              <Text>
                {formatMoney(judgeData?.judgeDef[0]?.costOfUselesenessMonth)}{" "}
                เดือน{" "}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าทนาย">
              <Text>{formatMoney(judgeData.attorneyFees)} บาท</Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าติดตาม">
              <Text>{formatMoney(judgeData.trackingFee)} บาท</Text>
            </Descriptions.Item>
            <Descriptions.Item label="ค่าธรรมเนียมศาล">
              <Text>{formatMoney(judgeData.fee)} บาท</Text>
            </Descriptions.Item>
          </Descriptions>
          <Text style={{ fontSize: 16, margin: 10 }}>
            <span style={{ color: "#888" }}>ผู้รับผิดชอบ: </span>
            <span style={{ fontWeight: 500 }}>
              {lawsuitData?.FNAME} {lawsuitData?.LNAME}
            </span>
            <span style={{ fontWeight: 500, marginLeft: 6 }}>
              ({lawsuitData?.NNAME})
            </span>
          </Text>
        </div>

        {/* loanNew */}
        {loanNew && (
          <>
            <Divider orientation="left">
              <CalendarOutlined /> ข้อมูลสัญญาใหม่
            </Divider>
            <div
              style={{
                background: "#e6f7ff",
                border: "1px solid #91d5ff",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "16px",
              }}
            >
              <Descriptions
                bordered
                size="small"
                column={{ xs: 1, sm: 2, md: 3 }}
              >
                <Descriptions.Item label="เลขสัญญาใหม่">
                  <Text strong copyable>
                    {loanNew.NEW_CONTNO || "-"}
                  </Text>
                </Descriptions.Item>
                <Descriptions.Item label="เลขสัญญาเดิม">
                  <Text copyable>{loanNew.ISSUNO || "-"}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="วันทำสัญญา">
                  {formatDate(loanNew.SDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="งวดแรก">
                  {formatDate(loanNew.FDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="งวดสุดท้าย">
                  {formatDate(loanNew.LDATE)}
                </Descriptions.Item>
                <Descriptions.Item label="จำนวนงวด">
                  <Tag color="blue">{loanNew.T_NOPAY} งวด</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="ค่างวด">
                  <Text strong style={{ color: "#1890ff" }}>
                    {formatMoney(loanNew.TOT_UPAY)} บาท
                  </Text>
                </Descriptions.Item>

                <Descriptions.Item label="ยอดคงเหลือ">
                  <Text strong style={{ color: "#fa541c" }}>
                    {formatMoney(loanNew.LOAN_NEW_TONBALANCE)} บาท
                  </Text>
                </Descriptions.Item>
              </Descriptions>
            </div>
          </>
        )}

        {/* AROTHR */}
        {arothrData && arothrData.length > 0 && (
          <>
            <Divider orientation="left">
              <DollarOutlined /> ศาลสั่งต้องจ่าย
            </Divider>
            <Table
              dataSource={arothrData}
              columns={[
                {
                  title: "รหัส",
                  dataIndex: "ARCONT",
                  key: "ARCONT",
                  render: (val) => (
                    <Text style={{ fontFamily: "monospace" }}>{val}</Text>
                  ),
                },
                {
                  title: "รายการ",
                  dataIndex: "PAYFOR",
                  key: "PAYFOR",
                  render: (val) => {
                    const option = arothrOptions.find((o) => o.value === val);
                    return <Tag color="blue">{option?.label || val}</Tag>;
                  },
                },
                {
                  title: "จำนวนเงิน",
                  dataIndex: "PAYAMT",
                  key: "PAYAMT",
                  align: "right",
                  render: (val) => <Text strong>{formatMoney(val)} บาท</Text>,
                },
                {
                  title: "ชำระแล้ว",
                  dataIndex: "SMPAY",
                  key: "SMPAY",
                  align: "right",
                  render: (val) => (
                    <Text style={{ color: "#52c41a" }}>
                      {formatMoney(val)} บาท
                    </Text>
                  ),
                },
              ]}
              rowKey="ARCONT"
              pagination={false}
              size="small"
              style={{ marginBottom: "16px" }}
              summary={(data) => {
                const totalPayamt = data.reduce(
                  (sum, r) => sum + Number(r.PAYAMT || 0),
                  0,
                );
                const totalSmpay = data.reduce(
                  (sum, r) => sum + Number(r.SMPAY || 0),
                  0,
                );
                return (
                  <Table.Summary.Row style={{ background: "#fafafa" }}>
                    <Table.Summary.Cell colSpan={2}>
                      <Text strong>รวมทั้งหมด</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      <Text strong>{formatMoney(totalPayamt)} บาท</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      <Text strong style={{ color: "#52c41a" }}>
                        {formatMoney(totalSmpay)} บาท
                      </Text>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </>
        )}
      </>
    );
  }, [judgeData, arothrData, arothrOptions]);

  // ========================================
  // Main Render
  // ========================================
  return (
    <>
      <Modal
        title={
          <Space>
            <FileTextOutlined />
            <span>
              รายละเอียดสัญญา - {dataDefault?.newContno || dataDefault?.CONTNO}
            </span>
          </Space>
        }
        open={open}
        onCancel={handleCancel}
        width={1200}
        footer={null}
        destroyOnHidden
      >
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          {renderJudgeInfo}
          {fileListByContract.length > 0 && (
            <>
              <Divider orientation="left">
                <FileSearchOutlined /> ดูข้อมูล
              </Divider>
              <div style={{ textAlign: "center", marginTop: 10 }}>
                <>
                  <Row gutter={[8, 8]} justify="center">
                    {fileListByContract.map((file) => {
                      const isPdf = file.path?.toLowerCase().endsWith(".pdf");
                      const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
                      const { label, color } = getDocLabel(
                        file.menuType,
                        file.imageType,
                      );

                      return (
                        <Col key={file.imageId} xs={8} sm={6} md={4}>
                          <div
                            style={{
                              border: `1px solid ${color}`,
                              borderRadius: 8,
                              padding: 8,
                              textAlign: "center",
                              position: "relative",
                            }}
                          >
                            {isPdf ? (
                              // ✅ PDF icon + ดู PDF ซ้อนกัน คลิกได้ทั้งก้อน
                              <div
                                onClick={() => {
                                  setPdfPreviewUrl(previewUrl);
                                  setPdfPreviewOpen(true);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: 80,
                                  background: "#fff1f0",
                                  borderRadius: 6,
                                  border: "1px dashed #ff4d4f",
                                  gap: 4,
                                }}
                              >
                                <FilePdfOutlined
                                  style={{ fontSize: 32, color: "#ff4d4f" }}
                                />
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "#ff4d4f",
                                    fontWeight: 500,
                                  }}
                                >
                                  <EyeOutlined style={{ marginRight: 4 }} />
                                  ดู PDF
                                </span>
                              </div>
                            ) : (
                              <img
                                src={previewUrl}
                                alt={file.path}
                                style={{
                                  width: "100%",
                                  height: 80,
                                  objectFit: "cover",
                                  borderRadius: 4,
                                }}
                              />
                            )}
                            {/* ✅ label ใต้ไฟล์ */}
                            <div
                              style={{
                                marginTop: 6,
                                background: color,
                                color: "#fff",
                                fontSize: 14,
                                borderRadius: 4,
                                padding: "1px 6px",
                                display: "inline-block",
                              }}
                            >
                              {label}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>

                  <PdfPreviewModal
                    open={pdfPreviewOpen}
                    url={pdfPreviewUrl}
                    onClose={() => {
                      setPdfPreviewOpen(false);
                      setPdfPreviewUrl("");
                    }}
                  />
                </>
              </div>
            </>
          )}
          {/* action Button */}
          <div style={{ textAlign: "center", marginTop: 24 }}>
            <Space size="large">
              <Button
                onClick={handleCancel}
                size="large"
                style={{ minWidth: 120, borderRadius: 8 }}
              >
                ปิด
              </Button>
              <Button
                type="primary"
                ghost
                icon={<FileTextOutlined />}
                onClick={() => setIsModalPayIn(true)} // ✅ เปิด Modal
                size="large"
                style={{ minWidth: 120, borderRadius: 8 }}
              >
                ดูใบเสร็จ
              </Button>
              <Button
                type="primary"
                ghost
                icon={<FileTextOutlined />}
                onClick={() => setIsModalProductTranfer(true)}
                size="large"
                style={{
                  minWidth: 140,
                  borderRadius: 8,
                  borderColor: "#52c41a",
                  color: "#52c41a",
                }}
              >
                ดูใบส่งสินค้า
              </Button>
              <Button
                type="primary"
                ghost
                icon={<FileTextOutlined />}
                onClick={() => setIsModalProductTranferAccount(true)}
                size="large"
                style={{
                  minWidth: 140,
                  borderRadius: 8,
                  borderColor: "#c4861a",
                  color: "#c47a1a",
                }}
              >
                รายละเอียดสินค้า
              </Button>
            </Space>
          </div>
        </Spin>
        {isModalpayIn && (
          <PayInSlipModal
            open={isModalpayIn}
            onClose={() => setIsModalPayIn(false)}
            dataDB2={dataDB2}
            billPayment={billPayment}
            lawsuitData={lawsuitData}
          />
        )}
        {isModalProductTranfer && (
          <ProductTranfer
            open={isModalProductTranfer}
            onClose={() => setIsModalProductTranfer(false)}
            dataDB2={dataDB2}
            billPayment={billPayment}
            judgeData={judgeData}
            lawsuitData={lawsuitData}
            dataDefault={dataDefault}
            status={status}
          />
        )}
        {isModalProductTranferAccount && (
          <ProductTranferAccount
            open={isModalProductTranferAccount}
            onClose={() => setIsModalProductTranferAccount(false)}
            dataDB2={dataDB2}
            billPayment={billPayment}
            judgeData={judgeData}
            lawsuitData={lawsuitData}
            dataDefault={dataDefault}
            status={status}
          />
        )}
      </Modal>
    </>
  );
};

export default BillAfterCourtOldData;
